import React, { useEffect } from 'react'
import { Checkbox } from '@mantine/core'
import { difference, concat } from 'lodash-es'

const Calculation = ({
  selectedStandardInfo,
  assignedInfo,
  setAssignedInfo,
}) => {
  const onSelectOptions = (e, item, option) => {
    const { slug } = item.field || {}

    setAssignedInfo(
      assignedInfo
        .map((v) => {
          if (v.slug === slug) {
            return {
              ...v,
              options: e.target.checked
                ? concat(v.options, [option.slug])
                : difference(v.options, [option.slug]),
            }
          }
          return v
        })
        .filter((v) => v)
    )
  }

  useEffect(() => {
    setAssignedInfo(
      selectedStandardInfo
        .map((item) => {
          const { slug, type } = item.field || {}
          if (type === 'dropSelect') {
            return { slug, options: [] }
          }
          return null
        })
        .filter((v) => v)
    )
  }, [selectedStandardInfo])

  return (
    <div
      className="w-full flex flex-col h-96 overflow-y-scroll"
      style={{ fontSize: '14px' }}
    >
      {selectedStandardInfo.map((item, index) => {
        const { selects, type } = (item && item.field) || {}

        return (
          <div key={item.objectId} className="w-full flex flex-col gap-2 mb-2">
            <div className="w-full flex items-center">
              <b style={{ fontSize: '14px' }}>
                {index + 1}:{item.standard.title}
              </b>
              {type !== 'dropSelect' && (
                <span className="text-red-500">
                  !!不是选择类型，无法参与计算
                </span>
              )}
              {type === 'dropSelect' && !item.field && (
                <span className="text-red-500">!!暂未绑定，请先绑定</span>
              )}
            </div>
            {selects && selects.length > 0 && (
              <div className="w-full flex items-center gap-2 flex-wrap">
                <span>统计项：</span>
                {selects.map((s) => {
                  return (
                    <div className="flex-1 flex items-center gap-2">
                      <Checkbox
                        size="xs"
                        onChange={(e) => {
                          onSelectOptions(e, item, s)
                        }}
                        value={s.slug}
                      />
                      <span>{s.title}</span>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default Calculation
